import type { ChecklistAdviceStatus } from '@arhs-fleetback/types/entities/checklists';

import { CHECKLISTS_API_URL } from 'constants/ApiConstants';

import type { ApiError, MetaAction } from 'modules/global/generic.types';

import * as actionTypes from '../actionTypes';
import type * as ActionTypes from '../types';
import type { DetailedChecklist } from '../types/projections/detailed-checklist';

export const setDisplayedLanguages = (
  languages: string[],
  meta: MetaAction = {}
): ActionTypes.SetDisplayedLanguagesAction => ({
  type: actionTypes.SET_DISPLAYED_LANGUAGES,
  payload: languages,
  meta,
});

export const setSelectedLocale = (locale: string, meta: MetaAction = {}): ActionTypes.SetSelectedLocaleAction => ({
  type: actionTypes.SET_SELECTED_LOCALE,
  payload: locale,
  meta,
});

export const setIsNew = (payload: undefined = undefined, meta: MetaAction = {}): ActionTypes.SetIsNewAction => ({
  type: actionTypes.SET_IS_NEW,
  payload,
  meta,
});

export const updateRequest = (checklist: DetailedChecklist, meta: MetaAction = {}): ActionTypes.UpdateRequestAction => ({
  type: actionTypes.UPDATE_REQUEST,
  payload: {
    request: {
      method: 'PUT',
      url: `checklists/api/${checklist?.id}`,
      data: checklist,
    },
  },
  meta,
});

export const updateSuccess = (checklist: DetailedChecklist, meta: MetaAction = {}): ActionTypes.UpdateSuccessAction => ({
  type: actionTypes.UPDATE_SUCCESS,
  payload: checklist,
  meta,
});

export const updateFailure = (message: ApiError, meta: MetaAction = {}): ActionTypes.UpdateFailureAction => ({
  type: actionTypes.UPDATE_FAILURE,
  payload: message,
  meta,
});

export const createRequest = (checklist: DetailedChecklist, meta: MetaAction = {}): ActionTypes.CreateRequestAction => ({
  type: actionTypes.CREATE_REQUEST,
  payload: {
    request: {
      method: 'POST',
      url: 'checklists/api',
      data: checklist,
    },
  },
  meta,
});

export const createSuccess = (checklist: DetailedChecklist, meta: MetaAction = {}): ActionTypes.CreateSuccessAction => ({
  type: actionTypes.CREATE_SUCCESS,
  payload: checklist,
  meta,
});

export const createFailure = (message: ApiError, meta: MetaAction = {}): ActionTypes.CreateFailureAction => ({
  type: actionTypes.CREATE_FAILURE,
  payload: message,
  meta,
});

export const patchAdvice = (
  { checklistId, adviceId, status }: { checklistId: string; adviceId: string; status: ChecklistAdviceStatus },
  meta: MetaAction = {}
): ActionTypes.PatchAdviceAction => ({
  type: actionTypes.PATCH_ADVICE,
  payload: {
    request: {
      url: `${CHECKLISTS_API_URL}/${checklistId}/advices/${adviceId}/status`,
      method: 'PATCH',
      data: { status },
    },
    adviceId,
    checklistId,
  },
  meta,
});

export const patchAdviceSuccess = (
  { checklistId, adviceId, ...rest }: ActionTypes.PatchAdviceResultActionPayload,
  meta: MetaAction = {}
): ActionTypes.PatchAdviceSuccessAction => ({
  type: actionTypes.PATCH_ADVICE_SUCCESS,
  payload: {
    adviceId,
    checklistId,
    ...rest,
  },
  meta,
});

export const patchAdviceFailure = (
  { checklistId, adviceId, ...rest }: ActionTypes.PatchAdviceResultActionPayload,
  message: ApiError,
  meta: MetaAction = {}
): ActionTypes.PatchAdviceFailureAction => ({
  type: actionTypes.PATCH_ADVICE_FAILURE,
  payload: {
    message,
    checklistId,
    adviceId,
    ...rest,
  },
  error: true,
  meta,
});

export const detailedChecklistIsReady = (
  isLoaded: boolean,
  meta: MetaAction = {}
): ActionTypes.DetailedChecklistIsReadyAction => ({
  type: actionTypes.APPLICATION_IS_READY,
  payload: isLoaded,
  meta,
});
